// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"sidebar_sidebar__Q88vf","clientsLink":"sidebar_clientsLink__3j9QR","langSelectLink":"sidebar_langSelectLink__3ooTr","langSelectActive":"sidebar_langSelectActive__3iHli"};